export const formatContent = (text) => {
    return text.replace(/<p>/g, '').split('</p>')
}
